import React from 'react';
import cls from 'classnames';
import { clsPrefix } from '../const';
import { CnStatisticSideProps } from './types';

/**
 * 指标卡 侧边栏组件
 * @param {*} props
 * @returns
 */
function CnStatisticSide({
  children,

  align = 'top',
}: CnStatisticSideProps) {
  return (
    <div
      className={cls(`${clsPrefix}-side`, {
        [`${clsPrefix}-side-top`]: align === 'top',
        [`${clsPrefix}-side-center`]: align === 'center',
        [`${clsPrefix}-side-bottom`]: align === 'bottom',
      })}
    >
      {children}
    </div>
  );
}

export { CnStatisticSide };
export type { CnStatisticSideProps };
